// src/pages/Ingles.online.js
import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect, useState } from "react"; // ✅ Import hooks
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import emailjs from 'emailjs-com';


function InglesOnline() {

  const [data, setData] = useState([]); // ✅ Initialize state
  
      useEffect(() => {
          //fetch("http://culturlingua-react.free.nf/api-public.php") // ✅ Make sure the path is correct
          fetch("https://culturlingua.com/api.php")
              .then((response) => response.json())
              .then((data) => setData(data)) // ✅ Save API response
              .catch((error) => console.error("Error fetching data:", error));
      }, []);
  
      const handleSubmit = (e) => {
        e.preventDefault();
    
        // Collect form data
        const form = e.target;
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
    
        // Send email using the new EmailJS template
        emailjs.send(
          'service_9lb5qor',      // Replace with your new service ID
          'template_lbosaog',      // Replace with the new template ID
          data,                   // Send form data as variables to the template
          'E34tJabSp_CQoJAQZ'          // Replace with your user ID
        )
        .then((response) => {
          console.log('Email sent successfully:', response);
          alert("Tu formulario ha sido enviado exitosamente.");
        })
        .catch((error) => {
          console.error('Email send failed:', error);
          alert("Hubo un error al enviar tu formulario. Intenta nuevamente.");
        });
      };

  return (
    <>
      {/* Metadatos para mejorar SEO */}
      <Helmet>
        <title>Inglés Online - Culturlingua Virtual | Aprende Inglés desde Casa | Tlaquepaque</title>
        <meta name="description" content="Aprende inglés online con profesores certificados. Clases virtuales interactivas con metodología MCER. ¡Inscríbete ahora!" />
        <meta name="keywords" content="inglés online, clases virtuales, aprender inglés, profesores certificados, MCER" />
        <meta property="og:title" content="Inglés Online - Culturlingua Virtual | Aprende Inglés desde Casa | Tlaquepaque" />
        <meta property="og:description" content="Aprende inglés online con profesores certificados desde la comodidad de tu casa." />
        <meta property="og:image" content="/assets/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />

                <meta
                  name="description"
                  content="Cursos de inglés en línea y presenciales en México. Profesores certificados, metodología basada en el MCER, certificaciones internacionales y talleres prácticos."
                />
                <meta
                  name="keywords"
                  content="clases de inglés, cursos de inglés, inglés en línea, inglés en México, aprender inglés rápido, certificación inglés MCER, Culturlingua, Tlaquepaque, Tlaquepaque Jalisco, clases de inglés en Tlaquepaque, escuela de inglés en Tlaquepaque, alternativa open english, alternativa the anglo academy, alternativa british council, cursos de inglés en línea México, cursos de inglés presenciales México"
                />
                <meta name="author" content="Culturlingua" />
      </Helmet>
      
      <main className="ingles-online-page">
        {/* Hero Section */}
        <section className="hero-virtual">
          <div className="virtual-background">
            <div className="floating-elements">
              <div className="floating-icon">💬</div>
              <div className="floating-icon">🌎</div>
              <div className="floating-icon">📚</div>
            </div>
            <div className="digital-overlay"></div>
          </div>
          
          <div className="container">
            <div className="hero-content">
              <h1 className="hero-title">Aprende Inglés <span className="virtual-highlight">Online</span></h1>
              <p className="hero-subtitle">Tu plataforma virtual para dominar el inglés con profesores certificados</p>
              <div className="hero-actions">
                <Link to="/Cursos" className="cta-button virtual-btn">Nuestros Cursos</Link>
                <Link to="https://wa.me/5213333449139?text=Hola%2C%20quisiera%20más%20información%20sobre%20los%20cursos." className="cta-button virtual-btn">Clase de Prueba gratuita</Link>
              </div>
              <div className="hero-features">
                <div className="feature-badge">
                  <span className="badge-icon">👥</span>
                  <span>Clases en vivo</span>
                </div>
                <div className="feature-badge">
                  <span className="badge-icon">🔄</span>
                  <span>Acceso a recursos 24/7</span>
                </div>
                <div className="feature-badge">
                  <span className="badge-icon">🏆</span>
                  <span>Certificación MCER</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Virtual Advantage Section */}
        <section className="virtual-advantage">
          <div className="container">
            <div className="section-header">
              <h2>La <span className="highlight">ventaja virtual</span> de Culturlingua</h2>
              <p>Diseñamos una experiencia de aprendizaje inmersiva que combina lo mejor de la enseñanza tradicional con la tecnología moderna</p>
            </div>
            
            <div className="advantage-grid">
              <div className="advantage-card">
                <div className="advantage-icon virtual-icon">💻</div>
                <h3>Aula Virtual Interactiva</h3>
                <p>Plataforma especializada con pizarra digital, salas de breakout y herramientas colaborativas en tiempo real.</p>
              </div>
              
              <div className="advantage-card">
                <div className="advantage-icon virtual-icon">📱</div>
                <h3>Plataformas Móviles Integrada</h3>
                <p>Accede a tu libro, recursos, tareas y materiales desde cualquier dispositivo, en cualquier momento.</p>
              </div>
              
              <div className="advantage-card">
                <div className="advantage-icon virtual-icon">🎮</div>
                <h3>Aprendizaje Gamificado</h3>
                <p>Sistema de recompensas, desafíos interactivos y juegos educativos que hacen divertido el aprendizaje.</p>
              </div>
              
              <div className="advantage-card">
                <div className="advantage-icon virtual-icon">📊</div>
                <h3>Seguimiento Inteligente</h3>
                <p>Dashboard personalizado que monitorea tu progreso y sugiere áreas de mejora.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Photo Gallery - Updated with virtual-focused images */}
        <section className="carousel-section virtual-carousel">
          <div className="container">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              loop={true}
              className="carousel-container"
            >
              <SwiperSlide>
                <div className="slide-content virtual-slide">
                  <img src="./assets/virtual-class.jpeg" alt="Aula virtual interactiva" />
                  <div className="text">
                    <h2>Aula Virtual Inmersiva</h2>
                    <p>Experiencia educativa completa con tecnología de punta para un aprendizaje efectivo.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="slide-content virtual-slide">
                  <img src="./assets/online-interaction.jpeg" alt="Interacción online" />
                  <div className="text">
                    <h2>Interacción en Tiempo Real</h2>
                    <p>Comunicación fluida con profesores y compañeros mediante chat, audio y video.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="slide-content virtual-slide">
                  <img src="./assets/digital-tools.jpeg" alt="Herramientas digitales" />
                  <div className="text">
                    <h2>Herramientas Digitales Integradas</h2>
                    <p>Acceso a recursos multimedia, ejercicios interactivos y biblioteca digital.</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </section>

        {/* Benefits Section - Updated for virtual focus */}
        <section className="benefits virtual-benefits">
          <div className="container">
            <div className="section-header">
              <h2>¿Por qué elegir nuestro <span className="highlight">inglés virtual</span>?</h2>
              <p>Diseñado específicamente para el aprendizaje online efectivo</p>
            </div>
            
            <div className="benefits-grid">
              <div className="benefit-card virtual-benefit">
                <div className="benefit-icon">
                  <span className="virtual-emoji">🎥</span>
                </div>
                <h3>Clases Flexibles y Contenido de Acceso Ilimitado</h3>
                <p>Revive cada lección las veces que necesites medinte los recursos. No te pierdes contenido.</p>
              </div>
              
              <div className="benefit-card virtual-benefit">
                <div className="benefit-icon">
                  <span className="virtual-emoji">🔄</span>
                </div>
                <h3>Flexibilidad Horaria</h3>
                <p>Adaptamos tu aprendizaje a tu ritmo de vida, con horarios flexibles disponibles.</p>
              </div>
              
              <div className="benefit-card virtual-benefit">
                <div className="benefit-icon">
                  <span className="virtual-emoji">👨‍🏫</span>
                </div>
                <h3>Tutorías Personalizadas 1 a 1*</h3>
                <p>Sesiones individuales con y repaso específico para acelerar tu progreso.</p>
                <p>*Aplican restricciones. Tutorías son pagadas por separado.</p>
              </div>
              
              <div className="benefit-card virtual-benefit">
                <div className="benefit-icon">
                  <span className="virtual-emoji">🌍</span>
                </div>
                <h3>Inmersión Cultural*</h3>
                <p>Conecta con estudiantes de todo el mundo sin salir de casa.</p>
                <p>*Sujetos a disponibilidad y variaciones locales.</p>
              </div>
              
              <div className="benefit-card virtual-benefit">
                <div className="benefit-icon">
                  <span className="virtual-emoji">💾</span>
                </div>
                <h3>Plataformas Todo-en-Uno</h3>
                <p>Clases, materiales, tareas y evaluaciones en un solo lugar integrado.</p>
              </div>
              
              
            </div>
          </div>
        </section>

        <section className="skills-section">
        <div className="skill speaking">
          <div className="skill-content">
            <h3>🗣️ Speaking en Vivo</h3>
            <p>Mejora tu fluidez y confianza al hablar.</p>
            <ul className="skill-features">
                    <li>Clubes de conversación temáticos</li>
                    <li>Pronunciación con tecnología de análisis</li>
                    <li>Feedback inmediato en cada sesión</li>
                  </ul>
          </div>
        </div>
        <div className="skill reading">
          <div className="skill-content">
            <h3>📖 Reading Digital</h3>
            <p>Desarrolla tu comprensión lectora con textos auténticos.</p>
            <p>Plataforma de lectura interactiva con textos adaptados y herramientas de apoyo.</p>
            <ul className="skill-features">
                    <li>Textos con dificultad progresiva</li>
                    <li>Análisis de progreso de comprensión</li>
                  </ul>
          </div>
        </div>
        <div className="skill listening">
          <div className="skill-content">
            <h3>🎧 Listening Interactivo</h3>
            <p>Entrena tu oído con audios y diálogos reales.</p>
            <p>Ejercicios con tecnología adaptativa que se ajusta a tu nivel.</p>
                  <ul className="skill-features">
                    <li>Ejercicios con velocidad ajustable</li>
                    <li>Actividades de comprensión automáticos</li>
                  </ul>
          </div>
        </div>
        <div className="skill writing">
          <div className="skill-content">
            <h3>✍️ Escribir</h3>
            <p>Aprende a expresarte de forma clara y precisa.</p>
            <p>Sistema de escritura con corrección instantánea y detección de errores.</p>
                  <ul className="skill-features">
                    <li>Corrección gramatical automática</li>
                    <li>Feedback automático</li>
                  </ul>
          </div>
        </div>
      </section>

        {/* Virtual Platform Demo */}
        <section className="platform-demo">
          <div className="container">
            <div className="demo-content">
              <div className="demo-text">
                <h2>Conoce nuestras <span className="highlight">plataformas virtuales</span></h2>
                <p>Diseñada específicamente para el aprendizaje de idiomas, con todas las herramientas que necesitas en un solo lugar.</p>
                <ul className="platform-features">
                  <li>Videollamadas HD con pizarra interactiva</li>
                  <li>Compartir pantalla y recursos multimedia</li>
                  <li>Salas de trabajo grupal configurables</li>
                  <li>Sistema de tareas y evaluaciones integrado</li>
                  <li>Panel de progreso y analytics de aprendizaje</li>
                </ul>
                <Link to="https://wa.me/5213333449139?text=Hola%2C%20quisiera%20más%20información%20sobre%20los%20cursos." className="cta-button virtual-btn">Clase de Prueba gratuita</Link>
              </div>
              <div className="demo-visual">
                <img src="./assets/platform-demo.png" alt="Demo de la plataforma virtual" className="platform-image" />
                <div className="floating-demo-elements">
                  <div className="demo-element">📅</div>
                  <div className="demo-element">💬</div>
                  <div className="demo-element">📊</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CEFR Based - Virtual Edition */}
        <section className="cefr virtual-cefr">
          <div className="container">
            <div className="cefr-content">
              <div className="cefr-text">
                <h2>Metodología <span className="highlight">MCER adaptada al entorno virtual</span></h2>
                <p>Nuestros cursos siguen el Marco Común Europeo de Referencia pero optimizados para la enseñanza online, con evaluaciones continuas y herramientas digitales de medición de progreso.</p>
                <div className="cefr-features">
                  <div className="cefr-feature">
                    <h4>Evaluación Continua Digital</h4>
                    <p>Tests automatizados que miden tu progreso en tiempo real.</p>
                  </div>
                  <div className="cefr-feature">
                    <h4>Portafolio Digital de Aprendizaje</h4>
                    <p>Registro automático de tus trabajos y avances en cada habilidad.</p>
                  </div>
                  <div className="cefr-feature">
                    <h4>Certificación con Validez Internacional</h4>
                    <p>Diploma digital verificable con estándares MCER.</p>
                  </div>
                </div>
              </div>
              <div className="cefr-visual">
                <img src="./assets/cefr-virtual.jpeg" alt="MCER adaptado a entornos virtuales" />
              </div>
            </div>
          </div>
        </section>

        {/* Next Course Dates */}
    <section className="next-dates">
        <h2>Próximos inicios de cursos</h2>
        <div className="dates-grid">
          {data.map((user) => (
            <div className="date-item" key={user.id}>
              <span>📅</span>
              <p >{user.fecha}</p>
            </div>
          ))}
        </div>
      </section>

        {/* Testimonials Section */}
        <section className="testimonials virtual-testimonials">
          <div className="container">
            <div className="section-header">
              <h2>Experiencias <span className="highlight">reales en nuestro entorno virtual y presencial</span></h2>
            </div>
            
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"Súper ubicada, fácil de llegar, la escuela y sus métodos de enseñanza son dinamicos, son divertidos, realmente sí aprendes!!  los profesores son atentos y profesionales, la atención al inicio en recepción muy buena, 100% recomendable!!"</p>
                </div>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>María Condes</h4>
                    <p>Estudiante B1 - GDL</p>
                  </div>
                </div>
              </div>
              
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"Considero que es una escuela no convencional donde el tipo de actividades te ayudan mucho a aprender. No tengas miedo, al final no eres malo en el inglés, solo faltaba que te guiaran. El tiempo aquí se te pasará muy rápido y cuando menos lo pienses ya habrás avanzado mucho."</p>
                </div>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>Denise</h4>
                    <p>Estudiante A2 - GDL</p>
                  </div>
                </div>
              </div>
              
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"Esta escuela podrá cambiar el rumbo de tus posibilidades, aunque pienses que aprender un idioma es difícil, aquí lo hacen ver más sencillo, las explicaciones y los profesores llegan a un execelente nivel para aprender desde cero."</p>
                </div>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>Frida Olguin</h4>
                    <p>Estudiante B2 - GDL</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form - Updated */}
        <section className="contact-form virtual-contact">
          <div className="container">
            <div className="contact-content">
              <div className="contact-text">
                <h2>¿List@ para comenzar tu <span className="highlight">experiencia virtual</span>?</h2>
                <p>Nuestr@s asesor@s te guiarán para elegir el curso perfecto según tus objetivos y disponibilidad.</p>
                <div className="contact-features">
                  <div className="contact-feature">
                    <span className="feature-icon">✅</span>
                    <span>Asesoramiento sin compromiso</span>
                  </div>
                  <div className="contact-feature">
                    <span className="feature-icon">✅</span>
                    <span>Clase de prueba gratuita</span>
                  </div>
                  <div className="contact-feature">
                    <span className="feature-icon">✅</span>
                    <span>Análisis de nivel sin costo</span>
                  </div>
                </div>
              </div>
              
              <div className="form-container">
                <form className="virtual-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input type="text" placeholder="Nombre completo" name="nombre" required />
                  </div>
                  <div className="form-group">
                    <input type="email" placeholder="Correo electrónico" name="correo" required />
                  </div>
                  <div className="form-group">
                    <input type="tel" placeholder="Teléfono" name="telefono" required />
                  </div>
                  <div className="form-group">
                    <textarea placeholder="Tu mensaje o consulta" name="pregunta" rows="4"></textarea>
                  </div>
                  <button type="submit" className="cta-button virtual-btn">Enviar Consulta</button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq virtual-faq">
          <div className="container">
            <div className="section-header">
              <h2>Preguntas <span className="highlight">frecuentes</span></h2>
            </div>
            
            <div className="faq-grid">
              <div className="faq-item">
                <h3>¿Necesito algún equipo especial para las clases?</h3>
                <p>Solo necesitas una computadora o tablet con conexión a internet, audífonos y micrófono. Te ayudaremos a configurar todo antes de tu primera clase.</p>
              </div>
              
              <div className="faq-item">
                <h3>¿Cómo son las clases en grupo online?</h3>
                <p>Nuestros grupos son reducidos para garantizar participación activa. Las clases son completamente interactivas con actividades colaborativas.</p>
              </div>
              
              <div className="faq-item">
                <h3>¿Puedo probar antes de inscribirme?</h3>
                <p>¡Por supuesto! Ofrecemos una clase de prueba gratuita para que conozcas la plataforma, al profesor y nuestra metodología.</p>
              </div>
              
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default InglesOnline;